import React, { useState } from 'react';
import { Link, Outlet, useLocation, useNavigate } from 'react-router-dom';
import styles from './ProductAdminLayout.module.css';
import { classNames } from '../../utils/helpers';
import { MenuIcon, XIcon } from '../../components/Icons';
import {
  GridIcon, BuildingIcon, ChartIcon, LogoutIcon, ReceiptIcon,
} from '../../pages/product-admin/ProductAdminIcons';

const navItems = [
  { path: '/product-admin/dashboard', label: 'Dashboard', icon: GridIcon },
  { path: '/product-admin/organizations', label: 'Organizations', icon: BuildingIcon },
  { path: '/product-admin/manual-registrations', label: 'Manual Registrations', icon: ReceiptIcon },
  { path: '/product-admin/usage', label: 'Usage & Activity', icon: ChartIcon },
];

// Shared shell (sidebar + top bar) for every product-admin page after login
function ProductAdminLayout() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  // Company and token detail pages belong to Organizations; registration pages to Manual Registrations
  const isActive = (item) => {
    if (item.path === '/product-admin/organizations') {
      return pathname === item.path || /^\/product-admin\/(company|token)\//.test(pathname);
    }
    if (item.path === '/product-admin/manual-registrations') {
      return pathname === item.path || pathname.startsWith(`${item.path}/`);
    }
    return pathname === item.path;
  };

  const logout = () => {
    localStorage.removeItem('productAdminToken');
    navigate('/product-admin/login');
  };

  return (
    <div className={styles.layout}>
      {sidebarOpen && <div className={styles.overlay} onClick={() => setSidebarOpen(false)} />}

      <aside className={classNames(styles.sidebar, sidebarOpen && styles.sidebarOpen)}>
        <div className={styles.sidebarHeader}>
          <div className={styles.brand}>
            <img src="/image_1_3.png" alt="DSC Platform" className={styles.logoIcon} />
          </div>
          <button type="button" className={styles.closeSidebar} onClick={() => setSidebarOpen(false)} aria-label="Close menu">
            <XIcon />
          </button>
        </div>
        <div className={styles.portalLabel}>PRODUCT ADMIN</div>
        <nav className={styles.nav}>
          {navItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={classNames(styles.navItem, isActive(item) && styles.navItemActive)}
              aria-current={isActive(item) ? 'page' : undefined}
              onClick={() => setSidebarOpen(false)}
            >
              <item.icon className={styles.navIcon} />
              <span>{item.label}</span>
            </Link>
          ))}
        </nav>
        <div className={styles.sidebarFooter}>
          <button type="button" className={styles.logoutButton} onClick={logout}>
            <LogoutIcon className={styles.navIcon} />
            <span>Logout</span>
          </button>
        </div>
      </aside>

      <div className={styles.main}>
        <header className={styles.header}>
          <button type="button" className={styles.menuButton} onClick={() => setSidebarOpen(true)} aria-label="Open menu">
            <MenuIcon />
          </button>
          <span className={styles.headerTitle}>Product Admin</span>
        </header>

        <main className={styles.content}>
          <Outlet />
        </main>
      </div>
    </div>
  );
}

export default ProductAdminLayout;
